import React, {useEffect, useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';

import Sitelist2 from '../../../reserves/routes/ReserveNew/sitelist2';

import {makeStyles} from '@material-ui/core/styles';
import {
    addressimage,
    addressimagehomessize,
    deletereserve,
    deletehome,
    listupdate, calendarupdate,
    checktokenapi,
    getprofilecustomize
} from "../../../../../api/api";
import {blue, green, purple} from "@material-ui/core/colors";
import IconButton from '@material-ui/core/IconButton'

import {useMediaQuery} from 'react-responsive'
import {useDispatch, useSelector} from "react-redux";
import {
    TelegramShareButton,
    WhatsappShareButton, FacebookShareCount, TwitterIcon,
    WhatsappIcon,
    TelegramIcon,
} from "react-share";
import Slide from '@material-ui/core/Slide';
import Switch from "@material-ui/core/Switch";
import ShareButton from 'react-web-share-button';
import URLSearchParams from "url-search-params";
import {useLocation} from "react-router-dom";
import {saveUpdate, userSignInSuccess} from "../../../../../actions";
import Header from "../../../../../containers/AppLayout/Vertical/Header";
import Widget from "../../../../../components/Widget";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import {NotificationContainer, NotificationManager} from "react-notifications";
import reload from "../../../../../assets/images/reload.png";
import share2 from "../../../../../assets/images/share.png";
import foreign from "../../../../../assets/images/foreign.png";
import Sitelist from "../../../reserves/routes/ReserveNew/sitelist";
import {ContentState, convertFromHTML, EditorState} from "draft-js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import check from "../../../../../assets/images/check.png";
import cancelrequest from "../../../../../assets/images/cancelrequest.png";


const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiMenu-paper': {

            right: 'auto',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },

    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: '#ffffff',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    },

    customMaxWidth: {
        maxWidth: "none" // arbitrary value
    }


}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        display: 'flex',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },


});


function toPersianNum(num, dontTrim) {

    if (num == null) {
        return '۰'
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
}


const DialogTitle = withStyles(styles)((props) => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h8">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


let typecalendar = true;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const useQuery = () => new URLSearchParams(useLocation().search);
const MySwal = withReactContent(Swal);
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
const Connectsites2 = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    // const {id, Name, Code, state, city, image, Roomnumber} = props.product;
    const [open, setOpen] = React.useState(false);
    const [openupdate, setOpenupdate] = React.useState(false);
    const [list, setList] = React.useState([]);
    const [id, setId] = React.useState(0);
    const [Name, setName] = React.useState('');
    const [Code, setCode] = React.useState('');
    const [openchecksite, setOpenchecksite] = React.useState(true);
    const [openchecksitelittle, setOpenchecksitelittle] = React.useState(false);
    const [openfull, setOpenfull] = React.useState(false);
    const [dialogclose, setDialogclose] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const [displayupdate, setDisplayupdate] = React.useState(false);
    const [loaderlist, setLoaderlist] = React.useState(true);
    const [activelist, setActivelist] = React.useState('');
    const [activelisteng, setActivelisteng] = React.useState('');
    const [share, setShare] = React.useState(false);
    const [shareurl, setShareurl] = React.useState("");
    const [menuState, setMenuState] = React.useState(false);
    const [lastsecond, setLastsecond] = React.useState(true);
    const [reserveready, setReserveready] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState(undefined);
    const [switchhpossibility, setSwitchhpossibility] = React.useState(false);
    const [checktoken, setChecktoken] = useState(false);
    const [showresult, setShowresult] = useState(false);
    const [mainlisttwo, setMainlisttwo] = useState([]);
    const isMobile = useMediaQuery({query: `(max-width: 760px)`});
    const query = useQuery();

    useEffect(() => {

    }, []);


    const handleCloseChecksite = () => {
        setOpenchecksite(false);
        if (window.Android) {
            window.Android.CloseWebView();
        }

    };

    const handleCloseChecksitelittle = () => {
        setOpenchecksitelittle(false);

    };

    const onClickreload = () => {

        if (activelisteng.length === 0) {
            Toast.fire({
                icon: 'error',
                title: 'لطفا حداقل به یکی از سایت ها متصل بشین'
            })
            return;
        }


        setMainlisttwo([]);
        setList([]);
        setShowresult(false);
        setOpenupdate(true);
        listupdate()
            .then((response) => {
                setList(response.data.resultreserve)
                setLoaderlist(false);
                if (response.data.resultreserve.length === 0) {
                    dispatch(saveUpdate(Number(0)));
                    localStorage.setItem("update", Number(0));
                    setDisplayupdate(true);
                } else {
                    setDisplayupdate(false);
                }
            })
            .catch((error) => {


            });
        MySwal.fire({
            title: 'توجه',
            text: 'این آپدیت فقط در سایت هایی انجام میشود که به آن متصل هستید که برای شما   ' + activelist,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonText: 'باشه',
            cancelButtonText: 'IOS',
            reverseButtons: true,
            allowOutsideClick: false,
            showCloseButton: true,
            willClose: () => {

            },
        }).then(result => {
            if (result.value) {

            } else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {

            }
        });

    };

    const handleCloseUpdate = () => {
        setOpenupdate(false);

    };

    const onClicknext = () => {
        setLoader(true);
        setDisplayupdate(true);
        // alert(activelisteng.toString());
        const formData = new FormData();
        formData.append("sites", activelisteng.toString());
        calendarupdate(formData)
            .then((response) => {
                setLoader(false);
                setDisplayupdate(false);
                setMainlisttwo(response.data.listresult);
                if (response.data.errorCode === 0) {

                    setShowresult(true);
                    let okok = false;
                    for (var i = 0; i < response.data.listresult.length; i++) {
                        if (response.data.listresult[i].result === true) {
                            okok = true;
                        } else {
                            okok = false;
                        }
                    }

                    if (okok) {
                        Toast.fire({
                            icon: 'success',
                            title: 'به روز رسانی انجام شد'
                        })
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'به روز رسانی انجام نشد'
                        })
                    }

                    listupdate()
                        .then((response) => {
                            setList(response.data.resultreserve)
                            setLoaderlist(false);
                            if (response.data.resultreserve.length === 0) {
                                setDisplayupdate(true);
                            } else {
                                setDisplayupdate(false);
                            }
                        })
                        .catch((error) => {


                        });
                    // alert('asd')
                    dispatch(saveUpdate(Number(0)));
                    localStorage.setItem("update", Number(0));


                } else {
                    Toast.fire({
                        icon: 'error',
                        title: response.data.errorDescription
                    })
                }

            })
            .catch((error) => {
                setLoader(false);
                setDisplayupdate(false);
            });

    };

    const getactive = (active, siteokeng) => {
        setActivelist(active);
        setActivelisteng(siteokeng);
        // alert(siteokeng.toString())
    };

    return (
        <div>
            {/*<div className="card product-item">*/}
            {/*<Header type={4} link={''} title="اتصال به سایت ها" back={false}/>*/}


            <div className="card-full animated slideInUpTiny animation-duration-3"
                 style={{overflow: 'scroll', padding: 20}}>


                <Widget className="no-gutters">


                    <form className="row " noValidate autoComplete="off">
                        <div className="col-12  col">

                            <div style={{
                                marginRight: 3,

                                marginBottom: 10,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>
                                جهت اتصال به سایت ها لازم است دکمه اتصال را بزنید
                            </div>

                            <div style={{
                                marginRight: 3,

                                marginBottom: 10,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>
                                چنان چه خطای مورد نظر (مشکل سایت مقصد یا TimeOut) بود , روی دکمه تلاش دوباره بزنید.
                            </div>
                            <div style={{
                                marginRight: 3,

                                marginBottom: 10,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>
                                چنان چه خطای مورد نظر (احراز هویت) بود , روی دکمه بزنید و دوباره وارد سایت شوید.
                            </div>

                            <Button style={{backgroundColor: '#00cdff'}}
                                    onClick={onClickreload}
                                    variant="contained"
                                    className="text-white iran-font">
                                <div>
                                    <img src={share2}
                                         style={{width: 20, marginLeft: 5, height: 20}}></img>
                                </div>
                                <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                    به روز رسانی تقویم
                                </div>
                            </Button>

                            <Sitelist2 handleCloseChecksite={handleCloseChecksite} activesite={getactive}/>

                        </div>
                    </form>

                </Widget>

            </div>


            <Dialog fullScreen TransitionComponent={Transition}
                    onClose={handleCloseUpdate} open={openupdate}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>
                    <div style={{
                        display: 'flex',
                        margin: 10,
                        fontSize: 15,
                        fontFamily: 'iransans',
                        fontWeight: 'bold'
                    }}>

                        <div> آپدیت سایت ها</div>
                        {/*<div style={{marginRight: 5}}> {Name} - {Code} </div>*/}

                    </div>

                    <IconButton onClick={handleCloseUpdate} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>

                <DialogContent dividers>
                    <div style={{width: '100%', height: '100%'}}>
                        {list.map((i, index) => (

                            <div style={{
                                display: 'flex', justifyContent: 'space-between', marginTop: 10,
                                alignItems: 'center', width: '100%', marginBottom: 20
                            }}>

                                <div style={{
                                    justifyContent: 'center',
                                    display: 'flex',
                                    fontFamily: 'iransans',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    padding: 0
                                }}>
                                    {list[index].Home.images.length > 0 ?
                                        <img className="img-fluid" style={{
                                            width: 50,
                                            height: 50,
                                            objectFit: 'cover',
                                            borderRadius: 8,
                                            marginLeft: 10
                                        }}
                                             src={addressimagehomessize(list[index].Home.images[0].preview)} alt="..."/>
                                        :
                                        <img className="img-fluid" style={{
                                            width: 50,
                                            height: 50,
                                            objectFit: 'cover',
                                            borderRadius: 8,
                                            marginLeft: 10
                                        }}
                                             src={addressimagehomessize("")} alt="..."/>
                                    }

                                    <div style={{fontSize: 22, fontWeight: 'bold'}}>ملک {list[index].Home.Name}</div>
                                </div>

                                <div style={{width: 500, display: 'ruby'}}>
                                    {list[index].Days.map((i, index2) => (
                                        <div style={{
                                            fontSize: 15,
                                            marginRight: 2,
                                            fontFamily: 'iransans',
                                            fontWeight: 'bold'
                                        }}>
                                            ,{toPersianNum(i)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                        {showresult ?
                            <div style={{
                                display: 'flex',
                                marginTop: 20,
                                fontSize: 15,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>
                                <div>نتیجه به روز رسانی :</div>
                                {/*<div style={{marginRight: 5}}> {Name} - {Code} </div>*/}
                            </div>
                            :
                            null
                        }


                        <div>
                            {mainlisttwo.map((i, index) => (

                                <div style={{
                                    display: 'flex', justifyContent: 'space-between',
                                    alignItems: 'center', width: '100%', marginTop: 20
                                }}>

                                    <div style={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        fontFamily: 'iransans',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        padding: 0
                                    }}>
                                        <div style={{
                                            fontSize: 22,
                                            fontWeight: 'bold'
                                        }}>{mainlisttwo[index].sitename}</div>
                                        {mainlisttwo[index].result ?
                                            // <CircularProgress size={24} className={classes.buttonProgress}/>
                                            null
                                            :
                                            // <img src={reload} style={{width: 25, height: 25, marginRight: 8}}></img>
                                            // <Button style={{marginRight: 8, backgroundColor: '#00cdff'}}
                                            //         onClick={onClickreload}
                                            //         variant="contained"
                                            //         className="text-white iran-font">
                                            //     <div>
                                            //         <img src={reload}
                                            //              style={{width: 20, marginLeft: 10, height: 20}}></img>
                                            //     </div>
                                            //     <div style={{color: '#ffffff', fontWeight: 'bold'}}>
                                            //         تلاش مجدد
                                            //     </div>
                                            // </Button>
                                            null
                                        }
                                    </div>
                                    {mainlisttwo[index].result ?
                                        <img src={check} style={{width: 40, height: 40, marginLeft: 5}}></img>
                                        :
                                        <div>
                                            <img src={cancelrequest}
                                                 style={{width: 40, height: 40, marginLeft: 5}}></img>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                        {!loaderlist && list.length === 0 ?
                            <div style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{marginRight: 2, fontFamily: 'iransans'}}>
                                    تاریخی برای آپدیت وجود ندارد
                                </div>
                            </div>
                            :
                            null
                        }

                        <div className="d-flex align-items-center"
                             style={{position: "absolute", bottom: 0, width: '100%', paddingLeft: 10}}>
                            {showresult ?
                                <Button onClick={() => setOpenupdate(false)} disabled={displayupdate}
                                        variant="contained" color="primary"
                                        style={{
                                            width: 200,
                                            height: 50,
                                            marginLeft: 5,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            cursor: 'pointer',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                            // backgroundColor: '#bb5eb4',
                                            backgroundColor: '#152e84',
                                            borderColor: '#152e84',
                                            borderRadius: 10,
                                        }} className="iran-font">
                                    {loader ?
                                        null
                                        :
                                        <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>بستن</div>
                                    }
                                    {loader &&
                                    <CircularProgress size={26} className={classes.buttonProgress}/>}
                                </Button>

                                :
                                <Button onClick={onClicknext} disabled={displayupdate} variant="contained"
                                        color="primary"
                                        style={{
                                            width: 200,
                                            height: 50,
                                            marginLeft: 5,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            cursor: 'pointer',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                            // backgroundColor: '#bb5eb4',
                                            backgroundColor: '#152e84',
                                            borderColor: '#152e84',
                                            borderRadius: 10,
                                        }} className="iran-font">
                                    {loader ?
                                        null
                                        :
                                        <div style={{fontSize: 15, color: '#fff', fontWeight: 'bold'}}>آپدیت</div>
                                    }
                                    {loader &&
                                    <CircularProgress size={26} className={classes.buttonProgress}/>}
                                </Button>

                            }

                        </div>

                        {loaderlist &&
                        <CircularProgress size={24} className={classes.buttonProgress}/>}
                    </div>
                </DialogContent>
            </Dialog>


        </div>
    )
};

export default Connectsites2;

